import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getVesEvents } from '@api/vesEvents';

import { extractQueryParams } from '@utils/common';

import { IIsEnabled } from '@interfaces/common/defaultDTO';
import { IVesEventsDTO } from '@interfaces/vesData/dto/vesEventsDTO';

import { VES_EVENTS } from '@constants/queryKeys';

const REFETCH_INTERVAL = 60 * 1000;

export const useQueryVesEvents = (params: IVesEventsDTO & IIsEnabled) => {
	const {
		accessPermission: {
			smoLightUpdater,
			smoLightViewer,
		},
	} = useAppSelector(auth);

	const {
		isEnabled,
		...dto
	} = params;

	const isSMOLightAccess = smoLightUpdater || smoLightViewer;

	const { data, isLoading } = useQuery({
		queryKey: [VES_EVENTS, dto],
		queryFn: extractQueryParams(getVesEvents),
		enabled: [isSMOLightAccess, isEnabled],
		refetchInterval: REFETCH_INTERVAL,
		refetchIntervalInBackground: true,
		refetchOnWindowFocus: true,
	});

	return {
		vesEvents: data?.items || [],
		isLoadingVesEvents: isLoading,
		countOfRecords: data?.count || 0,
	};
};
